import { unwrapResult } from '@reduxjs/toolkit'
import { Form, Input, Modal, ModalProps } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { addPartnerPlatformParams } from '../../services/partnerPlatform'
import { isAddPartnerPlatform } from './PartnerPlatformSlice'

interface TenantModalProps {
  partnerId?: number
  platformName?: string
  contactName?: string
  contactPhone?: string
  remark?: string
}

export const AddPartnerPlatformModel = ({
  partnerId,
  platformName,
  contactName,
  contactPhone,
  remark,
  onCancel,
  onOk,
  ...others
}: TenantModalProps & ModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [isLoading, setIsLoading] = useState(false)

  const firstColumnLayout = {
    labelCol: { flex: '8rem' },
    wrapperCol: { flex: '25rem' },
  }

  const required = {
    rules: [
      {
        required: true,
      },
    ],
  }
  useEffect(() => {
    if (partnerId) {
      form.setFieldsValue({
        platformName: platformName || '',
        contactName: contactName || '',
        contactPhone: contactPhone || '',
        remark: remark || '',
      })
    } else {
      form.resetFields()
    }
  }, [partnerId])

  return (
    <Modal
      {...others}
      title={`${partnerId ? '编辑' : '新建'}合作平台`}
      width={700}
      confirmLoading={isLoading}
      cancelText='取消'
      okText='确定'
      onCancel={(e) => {
        if (!partnerId) {
          form.resetFields()
        }
        onCancel && onCancel(e)
      }}
      onOk={(e) => {
        form
          .validateFields()
          .then((values: addPartnerPlatformParams) => {
            if (partnerId) {
              dispatch(isAddPartnerPlatform({ ...values, id: partnerId }))
                .then(unwrapResult)
                .then((e) => {
                  form.resetFields()
                  onOk && onOk(e)
                })
            } else {
              dispatch(isAddPartnerPlatform({ ...values }))
                .then(unwrapResult)
                .then((e) => {
                  form.resetFields()
                  onOk && onOk(e)
                })
            }
            console.log(values)
          })
          .catch(() => {
            console.log(78)

            // Do nothing.
          })
      }}
    >
      <Form
        form={form}
        colon={false}
        autoComplete='off'
        initialValues={{
          status: 1,
        }}
      >
        <Form.Item
          {...firstColumnLayout}
          label='合作平台名称'
          name='platformName'
          {...required}
          rules={[
            { required: true, message: '合作平台名称不能为空' },
            { max: 20, message: '最长20位' },
          ]}
        >
          <Input autoComplete='off' />
        </Form.Item>
        <Form.Item {...firstColumnLayout} label='联系人' name='contactName'>
          <Input autoComplete='off' maxLength={10} />
        </Form.Item>
        <Form.Item
          {...firstColumnLayout}
          label='联系电话'
          name='contactPhone'
          validateTrigger='onBlur'
          rules={[
            {
              pattern: /^(13[0-9]|14[0-9]|15[0-9]|18[0-9]|19[0-9])\d{8}$/,
              message: '请输入正确手机号',
            },
          ]}
        >
          <Input autoComplete='off' />
        </Form.Item>
        <Form.Item {...firstColumnLayout} label='备注' name='remark'>
          <Input autoComplete='off' maxLength={20} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
